import { FunctionComponent } from 'react';

const ProtectSvg: FunctionComponent<{ title?: string; className?: string }> = ({
  title,
  ...props
}) => (
  <svg
    {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    {title && <title>{title}</title>}
    <path fillRule="evenodd" clipRule="evenodd" d="M15.5888 0.0886308C15.8504 -0.0295436 16.1503 -0.0295436 16.4119 0.0886308C22.1598 2.68445 24.7471 3.51606 31.1121 4.6578C31.5654 4.73911 31.9045 5.1195 31.9335 5.57912C33.1462 24.7989 17.5534 31.4527 16.3739 31.9277C16.1342 32.0243 15.8665 32.0243 15.6268 31.9277C14.4473 31.4527 -1.14548 24.7989 0.067172 5.57912C0.0961716 5.1195 0.435325 4.73911 0.888627 4.6578C7.2536 3.51606 9.84092 2.68445 15.5888 0.0886308ZM22.4239 9.47439C22.8415 9.83585 22.887 10.4674 22.5255 10.8849L14.5351 20.1158C14.3545 20.3244 14.0958 20.4491 13.8201 20.4604C13.5444 20.4718 13.2763 20.3687 13.0792 20.1756L9.53115 16.6996C9.13663 16.3131 9.13013 15.68 9.51663 15.2855C9.90312 14.891 10.5363 14.8845 10.9308 15.271L13.7191 18.0026L21.0134 9.57599C21.3748 9.15842 22.0064 9.11293 22.4239 9.47439Z" fill="currentcolor" />
  </svg>
);

export default ProtectSvg;
